import { useMemo } from "react";
import { Settings } from "src/components/WysiwygEditor/lexical/context/SettingsContext/settings";
import * as GQL from "src/types/graphql";
import { VariablesContext } from "src/types/messages/variables";

function getVariablesContext(messageTemplateType: string): VariablesContext {
  return {
    type: "triggered",
    messageTemplateType: messageTemplateType as GQL.message_template_type_enum,
  };
}

export function useLexicalEditorSettings(messageTemplateType: string) {
  return useMemo(() => {
    const variablesContext = getVariablesContext(messageTemplateType);

    const emailEditorSettings: Partial<Settings> = {
      enableAutofocus: true,
      enableVariables: true,
      variablesContext,
    };

    const smsEditorSettings: Partial<Settings> = {
      enableVariables: true,
      enableSmsStats: true,
      variablesContext,
    };

    return {
      emailEditorSettings,
      smsEditorSettings,
    };
  }, [messageTemplateType]);
}
